// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum ItemApprovalMethod {
  ApproveAll = "APPROVE_ALL",
  ApproveSelected = "APPROVE_SELECTED",
}
export default ItemApprovalMethod;
